<div class="wrapper wrap">
  <div
    class="container"
    *ngIf="childrenDepartments && childrenDepartments.length > 0"
  >
    <div class="department-block mt-4">
      <div class="wrapper" role="main">
        <div class="row">
          <div class="mb-4 text-white list--blockgrid__section-title">
            <h1
              class="panel-header"
              tabindex="0"
              attr.aria-label="{{ 'COMMON.APPOINTMENTS_HEADING' | translate }}"
              role="header"
              id="main-content"
            >
              <span class="material-icons icon" aria-hidden="true">chevron_right</span
              >{{ 'COMMON.APPOINTMENTS_HEADING' | translate }}
            </h1>
          </div>

          <div class="department-div">
            <div
              class="department"
              *ngFor="let department of childrenDepartments"
              (click)="selectDepartment(department)"
              tabindex="0"
              [attr.aria-label]="'Department' + department.name"
              role="button"
            >
              {{ department.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
